import TheGrid from '@/views/products/top10/grid'
import Edit from '@/views/products/top10/edit'

export default {
  path: '/products/top10',
  redirect: '/products/top10/index',
  name: 'top10',
  meta: {
    auth: {
      redirect: {
        name: 'top10.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Produtos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'top10.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'top10.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'top10.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
